import React from "react";
import { Divider, notification } from "antd";
import dividerStyles from "../../Shared/Styles/DividerStyles.module.scss";
import { ITripDetails } from "../../ServiceUsers/Interfaces/ITripDetails";
import TripLegCard from "../../Shared/Cards/TripCards/TripLegCard";
import Spinner from "../../../assets/Loader/GoogleSvgLoader/GoogleLoader";

type Props = {
  isLoading: boolean;
  favoriteTrip: ITripDetails[];
};

function FavoriteTripDetails({ isLoading, favoriteTrip }: Props) {
  return isLoading ? (
    <Spinner />
  ) : (
    <>
      {favoriteTrip.map((leg: ITripDetails, index: number) => (
        <React.Fragment key={leg.bookingId}>
          <TripLegCard leg={leg} legNumber={index + 1} isMobileView={true} />
          {favoriteTrip.length > index + 1 && (
            <Divider className={dividerStyles.dashedPrimaryDivider} dashed />
          )}
        </React.Fragment>
      ))}
    </>
  );
}

export default FavoriteTripDetails;
